export const BREAKPOINTS = {
  MOBILE: '768px',
  TABLET: '1024px',
  DESKTOP: '1280px',
  LARGE_DESKTOP: '1536px',
} as const

export const MEDIA_QUERIES = {
  LARGER_THAN_1280: '(min-width: 1280px)',
  LARGER_THAN_1050: '(min-width: 1050px)',
} as const

export const COLORS = {
  PRIMARY: 'green',
  SECONDARY: 'teal',
} as const
